import { Component } from '@angular/core';
import { Sidebar } from '../shared/sidebar/sidebar';
import { Header } from '../shared/header/header';
import { RouterOutlet } from '@angular/router';
@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [Header, Sidebar,RouterOutlet],
  templateUrl: './layout.html',
  styleUrl: './layout.css',
})
export class Layout {

}
